module.exports = __webpack_public_path__ + "img/withholding-tax.e8bdfb66.png";